import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useInHouse } from "./inHousePermissions";
import { canAccessRoute, defaultRouteForRole } from "../utils/roleAccess";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { currentUser, loading: authLoading } = useAuth();
  const location = useLocation();
  const { currentUserRecord, loading: inHouseLoading } = useInHouse();

  if (authLoading || inHouseLoading) {
    return <div></div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (!currentUserRecord) {
    return <Navigate to="/not-authorized" state={{ from: location }} />;
  }

  if (
    canAccessRoute(
      currentUserRecord.role,
      location.pathname,
      currentUserRecord.extraRoutes
    )
  ) {
    return <>{children}</>;
  }
  return (
    <Navigate
      to={defaultRouteForRole(
        currentUserRecord.role,
        currentUserRecord.extraRoutes
      )}
      state={{ from: location }}
    />
  );
};

export default ProtectedRoute;
